import CheckboxFormikField from 'components/forms/CheckboxFormikField';
import ComboboxFormikField from 'components/forms/ComboboxFormikField';
import CustomCheckbox from 'components/forms/CustomCheckbox';
import InputFormikField from 'components/forms/InputFormikField';
import TextareaFormikField from 'components/forms/TextareaFormikField';
import ItemsSelectionComponent from 'components/portfolios/ItemsSelectionComponent';
import Tree from 'components/react-tree/Tree';

export interface FormattedMessageProps {
    id: string;
    defaultMessage?: string;
    values?: Record<string, any>;
}

export const TypedInputFormikField = InputFormikField as React.FC<any>;
export const TypedComboboxFormikField = ComboboxFormikField as React.FC<any>;
export const TypedTextareaFormikField = TextareaFormikField as React.FC<any>;
export const TypedItemsSelectionComponent = ItemsSelectionComponent as React.FC<any>;
export const TypedTree = Tree as React.FC<any>;
export const TypedItemSelectionComponent = ItemsSelectionComponent as React.FC<any>;
export const TypedCustomCheckbox = CustomCheckbox as React.FC<any>;
export const TypedCheckboxFormikField = CheckboxFormikField as React.FC<any>;
